import { Box, VStack, HStack, Text, IconButton } from '@chakra-ui/react';
import { FiHeart, FiThumbsDown, FiShare2, FiGift } from 'react-icons/fi';
import { FaHeart, FaThumbsDown } from 'react-icons/fa';
import IconWrapper from './IconWrapper';

interface VideoInteractionsProps {
  showControls: boolean;
  isLiked: boolean;
  isDisliked: boolean;
  likes: number;
  dislikes: number;
  onLike: () => void;
  onDislike: () => void;
  onShare: () => void;
  onDonate: () => void;
}

const VideoInteractions: React.FC<VideoInteractionsProps> = ({
  showControls,
  isLiked,
  isDisliked,
  likes,
  dislikes,
  onLike,
  onDislike,
  onShare,
  onDonate,
}) => {
  if (!showControls) return null;

  return (
    <>
      {/* Right Side Interaction Bar */}
      <Box
        position="absolute"
        right={4}
        top="50%"
        transform="translateY(-50%)"
        zIndex={10}
      >
        <VStack gap={6} align="center">
          <VStack gap={1}>
            <IconButton
              aria-label="Like"
              icon={<IconWrapper icon={isLiked ? FaHeart : FiHeart} size={20} />}
              variant="ghost"
              colorScheme="white"
              color={isLiked ? "red.400" : "white"}
              onClick={onLike}
            />
            <Text color="white" fontSize="md" fontWeight="bold">
              {likes > 999 ? `${(likes / 1000).toFixed(1)}k` : likes.toLocaleString()}
            </Text>
          </VStack>

          <VStack gap={1}>
            <IconButton
              aria-label="Dislike"
              icon={<IconWrapper icon={isDisliked ? FaThumbsDown : FiThumbsDown} size={20} />}
              variant="ghost"
              colorScheme="white"
              color={isDisliked ? "red.400" : "white"}
              onClick={onDislike}
            />
            <Text color="white" fontSize="md" fontWeight="bold">
              {dislikes.toLocaleString()}
            </Text>
          </VStack>

          <VStack gap={1}>
            <IconButton
              aria-label="Share"
              icon={<IconWrapper icon={FiShare2} size={20} />}
              variant="ghost"
              colorScheme="white"
              onClick={onShare}
            />
            <Text color="white" fontSize="md" fontWeight="medium">
              Share
            </Text>
          </VStack>

          <VStack gap={1}>
            <IconButton
              aria-label="Donate"
              icon={<IconWrapper icon={FiGift} size={20} />}
              variant="ghost"
              colorScheme="white"
              onClick={onDonate}
            />
            <Text color="white" fontSize="md" fontWeight="medium">
              Donate
            </Text>
          </VStack>
        </VStack>
      </Box>

    </>
  );
};

export default VideoInteractions;
